export default "/assets/chat.svg";